'use client';

import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@tanstack/react-query';
import clsx from 'clsx';
import Image from 'next/image';
import type { Dispatch, SetStateAction } from 'react';
import getLocList from '@/app/cc/_apis/ansimPartner/getLocList';
import type { LocItem, SelectedLoc } from '@/app/cc/_types/types';
import styles from './LocSheet.module.scss';
export interface LocSheetProps {
  selectedLoc: SelectedLoc;
  setSelectedLoc: Dispatch<SetStateAction<SelectedLoc>>;
}
const fetchLocList = (bjdCd: string) => getLocList(bjdCd).then(res => res.data.items);
export default function LocSheet(t0) {
  const $ = _c(67);
  const {
    selectedLoc,
    setSelectedLoc
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      queryKey: ["locList", ""],
      queryFn: _temp,
      staleTime: Number.POSITIVE_INFINITY,
      gcTime: Number.POSITIVE_INFINITY
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    data: t2
  } = useQuery(t1);
  let t3;
  if ($[1] !== t2) {
    t3 = t2 === undefined ? [] : t2;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const sidoList = t3;
  let t4;
  let t5;
  if ($[3] !== selectedLoc.sido.bjdCd) {
    t4 = ["locList", selectedLoc.sido.bjdCd];
    t5 = () => fetchLocList(selectedLoc.sido.bjdCd);
    $[3] = selectedLoc.sido.bjdCd;
    $[4] = t4;
    $[5] = t5;
  } else {
    t4 = $[4];
    t5 = $[5];
  }
  const t6 = !!selectedLoc.sido.bjdCd;
  let t7;
  if ($[6] !== t4 || $[7] !== t5 || $[8] !== t6) {
    t7 = {
      queryKey: t4,
      queryFn: t5,
      enabled: t6,
      staleTime: Number.POSITIVE_INFINITY,
      gcTime: Number.POSITIVE_INFINITY
    };
    $[6] = t4;
    $[7] = t5;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  const {
    data: t8
  } = useQuery(t7);
  let t9;
  if ($[10] !== t8) {
    t9 = t8 === undefined ? [] : t8;
    $[10] = t8;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  const gugunList = t9;
  const t10 = selectedLoc.gugun?.bjdCd;
  let t11;
  if ($[12] !== t10) {
    t11 = ["locList", t10];
    $[12] = t10;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] !== selectedLoc.gugun?.bjdCd) {
    t12 = () => fetchLocList(selectedLoc.gugun?.bjdCd ?? "");
    $[14] = selectedLoc.gugun?.bjdCd;
    $[15] = t12;
  } else {
    t12 = $[15];
  }
  const t13 = !!selectedLoc.gugun?.bjdCd;
  let t14;
  if ($[16] !== t11 || $[17] !== t12 || $[18] !== t13) {
    t14 = {
      queryKey: t11,
      queryFn: t12,
      enabled: t13,
      staleTime: Number.POSITIVE_INFINITY,
      gcTime: Number.POSITIVE_INFINITY
    };
    $[16] = t11;
    $[17] = t12;
    $[18] = t13;
    $[19] = t14;
  } else {
    t14 = $[19];
  }
  const {
    data: t15
  } = useQuery(t14);
  let t16;
  if ($[20] !== t15) {
    t16 = t15 === undefined ? [] : t15;
    $[20] = t15;
    $[21] = t16;
  } else {
    t16 = $[21];
  }
  const bjdList = t16;
  let t17;
  if ($[22] !== selectedLoc.sido.bjdCd || $[23] !== setSelectedLoc) {
    t17 = sido => {
      if (selectedLoc.sido.bjdCd === sido.bjdCd) {
        return;
      }
      setSelectedLoc(prev => ({
        ...prev,
        sido: {
          name: sido.sidoNm,
          bjdCd: sido.bjdCd
        },
        gugun: null,
        bjd: null,
        bjdCd: sido.bjdCd
      }));
    };
    $[22] = selectedLoc.sido.bjdCd;
    $[23] = setSelectedLoc;
    $[24] = t17;
  } else {
    t17 = $[24];
  }
  const handleSelectSido = t17;
  let t18;
  if ($[25] !== selectedLoc.gugun?.bjdCd || $[26] !== setSelectedLoc) {
    t18 = gugun => {
      if (selectedLoc.gugun?.bjdCd === gugun.bjdCd) {
        return;
      }
      setSelectedLoc(prev_0 => ({
        ...prev_0,
        gugun: {
          name: gugun.gugunNm,
          bjdCd: gugun.bjdCd
        },
        bjd: null,
        bjdCd: gugun.bjdCd
      }));
    };
    $[25] = selectedLoc.gugun?.bjdCd;
    $[26] = setSelectedLoc;
    $[27] = t18;
  } else {
    t18 = $[27];
  }
  const handleSelectGugun = t18;
  let t19;
  if ($[28] !== selectedLoc.bjd?.bjdCd || $[29] !== setSelectedLoc) {
    t19 = bjd => {
      if (selectedLoc.bjd?.bjdCd === bjd.bjdCd) {
        return;
      }
      setSelectedLoc(prev_1 => ({
        ...prev_1,
        bjd: {
          name: bjd.bjdNm,
          bjdCd: bjd.bjdCd
        },
        bjdCd: bjd.bjdCd
      }));
    };
    $[28] = selectedLoc.bjd?.bjdCd;
    $[29] = setSelectedLoc;
    $[30] = t19;
  } else {
    t19 = $[30];
  }
  const handleSelectBjd = t19;
  let t20;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <Image src="/cc/image/icon_arrowRight_locsheet.svg" alt="arrow_right" width={16} height={16} />;
    $[31] = t20;
  } else {
    t20 = $[31];
  }
  const t21 = selectedLoc.gugun ? selectedLoc.gugun.name : "\uC2DC\uAD70\uAD6C";
  let t22;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <Image src="/cc/image/icon_arrowRight_locsheet.svg" alt="arrow_right" width={16} height={16} />;
    $[32] = t22;
  } else {
    t22 = $[32];
  }
  const t23 = selectedLoc.bjd ? selectedLoc.bjd.name : "\uC74D\uBA74\uB3D9";
  let t24;
  if ($[33] !== selectedLoc.sido.name || $[34] !== t21 || $[35] !== t23) {
    t24 = <div className={styles.selectedLocContainer}>{selectedLoc.sido.name}{t20}{t21}{t22}{t23}</div>;
    $[33] = selectedLoc.sido.name;
    $[34] = t21;
    $[35] = t23;
    $[36] = t24;
  } else {
    t24 = $[36];
  }
  let t25;
  if ($[37] !== handleSelectSido || $[38] !== selectedLoc.sido.bjdCd || $[39] !== sidoList) {
    let t26;
    if ($[41] !== handleSelectSido || $[42] !== selectedLoc.sido.bjdCd) {
      t26 = item => <button type="button" className={clsx(styles.addressItem, selectedLoc.sido?.bjdCd === item.bjdCd && styles.selected)} key={item.bjdCd} onClick={() => handleSelectSido(item)}>{item.sidoNm}</button>;
      $[41] = handleSelectSido;
      $[42] = selectedLoc.sido.bjdCd;
      $[43] = t26;
    } else {
      t26 = $[43];
    }
    t25 = sidoList.map(t26);
    $[37] = handleSelectSido;
    $[38] = selectedLoc.sido.bjdCd;
    $[39] = sidoList;
    $[40] = t25;
  } else {
    t25 = $[40];
  }
  let t26;
  if ($[44] !== t25) {
    t26 = <div className={styles.addressContainer}>{t25}</div>;
    $[44] = t25;
    $[45] = t26;
  } else {
    t26 = $[45];
  }
  let t27;
  if ($[46] !== gugunList || $[47] !== handleSelectGugun || $[48] !== selectedLoc.gugun?.bjdCd) {
    let t28;
    if ($[50] !== handleSelectGugun || $[51] !== selectedLoc.gugun?.bjdCd) {
      t28 = item_0 => <button type="button" className={clsx(styles.addressItem, selectedLoc.gugun?.bjdCd === item_0.bjdCd && styles.selected)} key={item_0.bjdCd} onClick={() => handleSelectGugun(item_0)}>{item_0.gugunNm}</button>;
      $[50] = handleSelectGugun;
      $[51] = selectedLoc.gugun?.bjdCd;
      $[52] = t28;
    } else {
      t28 = $[52];
    }
    t27 = gugunList.map(t28);
    $[46] = gugunList;
    $[47] = handleSelectGugun;
    $[48] = selectedLoc.gugun?.bjdCd;
    $[49] = t27;
  } else {
    t27 = $[49];
  }
  let t28;
  if ($[53] !== t27) {
    t28 = <div className={styles.addressContainer}>{t27}</div>;
    $[53] = t27;
    $[54] = t28;
  } else {
    t28 = $[54];
  }
  let t29;
  if ($[55] !== bjdList || $[56] !== handleSelectBjd || $[57] !== selectedLoc.bjd || $[58] !== setSelectedLoc) {
    t29 = <div className={styles.addressContainer}>{bjdList.length > 0 ? <><button type="button" className={clsx(styles.addressItem, selectedLoc.bjd === null && styles.selected)} onClick={() => {
          setSelectedLoc(_temp2);
        }}>전체</button>{bjdList.map(item_1 => <button type="button" className={clsx(styles.addressItem, selectedLoc.bjd?.bjdCd === item_1.bjdCd && styles.selected)} key={item_1.bjdCd} onClick={() => handleSelectBjd(item_1)}>{item_1.bjdNm}</button>)}</> : <div className={styles.addressItem} />}</div>;
    $[55] = bjdList;
    $[56] = handleSelectBjd;
    $[57] = selectedLoc.bjd;
    $[58] = setSelectedLoc;
    $[59] = t29;
  } else {
    t29 = $[59];
  }
  let t30;
  if ($[60] !== t26 || $[61] !== t28 || $[62] !== t29) {
    t30 = <div className={styles.locListContainer}>{t26}{t28}{t29}</div>;
    $[60] = t26;
    $[61] = t28;
    $[62] = t29;
    $[63] = t30;
  } else {
    t30 = $[63];
  }
  let t31;
  if ($[64] !== t24 || $[65] !== t30) {
    t31 = <div className={styles.locSheet}>{t24}{t30}</div>;
    $[64] = t24;
    $[65] = t30;
    $[66] = t31;
  } else {
    t31 = $[66];
  }
  return t31;
}
function _temp2(prev_2) {
  return {
    ...prev_2,
    bjd: null,
    bjdCd: prev_2.gugun?.bjdCd ?? prev_2.sido.bjdCd
  };
}
function _temp() {
  return fetchLocList("");
}